export default {

  getTodayFormatted(format){

    switch (format) {
      case 'yyyy-mm-dd':
        function twoDigit(n) { return (n < 10 ? '0' : '') + n; }
        let now = new Date();
        return '' + now.getFullYear() + '-' + twoDigit(now.getMonth() + 1) + '-' + twoDigit(now.getDate())
      default:
        return '';
    }
  }

}